module.exports = __webpack_public_path__ + "static/img/tab-ten.5de84b1d.png";